import {Button, Form, Table} from "react-bootstrap";
import {useFieldArray, UseFormReturn} from "react-hook-form";
import { SettingsData } from "../../Types/Settings";
import useAuth from "../../Hooks/useAuth";

export interface GeneralEditorProps {
  form: UseFormReturn<SettingsData>;
  data?: SettingsData;
}

export default function CountryEditor({form, data}: GeneralEditorProps) {
  const auth = useAuth();
  const {fields: countryFields, append: countryAppend} = useFieldArray({control: form.control, name: "countries"});
  return <>
    <Table striped bordered size="sm" hover className="m-0">
      <thead>
      <tr>
        <th>ID</th>
        <th>Short Name</th>
        <th>Full Name</th>
      </tr>
      </thead>
      <tbody>
      {countryFields.map((field, index) => {
        // Workaround for "<Value> as <Type>" syntax not working
        const jobString: any = (i: string) => `countries.${index}.${i}`;

        // Keep Data
        if (!field.newCountry) form.register(jobString("parameterKey"))
        return (
          <tr key={index.toString()}>
            {field.newCountry ?
              <td className="p-0">
                <Form.Control
                  readOnly={!auth.isAdmin}
                  placeholder="ID (Required)"
                  defaultValue={field.parameterKey || ""}
                  {...form.register(jobString("parameterKey"), {required: true})}
                />
              </td> : <td>{field.parameterKey}</td>}
            <td className="p-0">
              <Form.Control
                readOnly={!auth.isAdmin}
                defaultValue={field.description || ""}
                {...form.register(jobString("description"))}
              />
            </td>
            <td className="p-0">
              <Form.Control
                readOnly={!auth.isAdmin}
                defaultValue={field.valueString ?? ""}
                {...form.register(jobString("valueString"))}
              />
            </td>
          </tr>
        )
      })}
      </tbody>
    </Table>
    {auth.isAdmin && <Button className="m-2" onClick={() => {
      countryAppend({
        parameterKey: "",
        description: "",
        isDefault: false,
        valueString: "",
        newCountry: true,
      })
    }}>Add Country</Button>}
  </>
}